var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010002;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.7,3.9C116.3,3.9,3.2,116.9,3.2,256.4s113,252.5,252.5,252.5s252.5-113.1,252.5-252.5S395.2,3.9,255.7,3.9z  M255.7,495.2c-131.9,0-238.8-106.9-238.8-238.8S123.8,17.6,255.7,17.6s238.8,106.9,238.8,238.8S387.6,495.2,255.7,495.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M367.1,144.9c-5.6-5.6-14.7-5.6-20.3,0L255.7,236l-91.1-91.1c-5.6-5.6-14.7-5.6-20.3,0c-5.6,5.6-5.6,14.7,0,20.3l91.1,91.1 l-91.1,91.1c-5.6,5.6-5.6,14.7,0,20.3c2.8,2.8,6.5,4.3,10.1,4.3c3.6,0,7.3-1.4,10.1-4.3l91.1-91.1l91.1,91.1 c2.8,2.8,6.5,4.3,10.1,4.3c3.7,0,7.3-1.4,10.1-4.3c5.6-5.6,5.6-14.7,0-20.3l-90.9-91.1l91.1-91.1 C372.8,159.6,372.8,150.6,367.1,144.9L367.1,144.9z M367.1,144.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.320866a6764c332147241998fd9a48f1.svg";
export { ForwardRef as ReactComponent };